import React from 'react';
import PropTypes from 'prop-types';
import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import crossIcon from 'assets/images/icons/cross-grey.svg';

const Drawer = ({
  title,
  handleClose,
  placement = 'end',
  backdrop = true,
  classes,
  style,
  headerClasses,
  bodyClasses,
  bodyComponent,
}) => {
  const { t } = useTranslation();
  return (
    <Offcanvas
      show={true}
      onHide={handleClose}
      placement={placement}
      backdrop={backdrop ? 'static' : false}
      className={`${classes ?? ''}`}
      style={style || {}}
      enforceFocus={false}
    >
      <div
        className={`d-flex justify-content-between align-content-center border-bottom-grey-10-h-1 ${
          headerClasses ?? ''
        }`}
      >
        <label className='theme-font-inter-semi-bold theme-size-1_3 theme-text-black-1'>
          {t(title)}
        </label>
        <div className='p-2 d-flex align-content-center cursor-pointer' onClick={handleClose}>
          <img src={crossIcon} className='w-100 h-100' />
        </div>
      </div>
      <div className={`flex-grow-1 overflow-y-auto ${bodyClasses ?? ''}`}>{bodyComponent}</div>
    </Offcanvas>
  );
};

Drawer.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
  classes: PropTypes.string,
  style: PropTypes.object,
  headerClasses: PropTypes.string,
  bodyClasses: PropTypes.string,
  backdrop: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  bodyComponent: PropTypes.object.isRequired,
};

export default Drawer;
